import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { HeartHandshake } from 'lucide-react';
export function MethodSection() {
  return <section className="py-20 px-4 bg-[#FFF0E6]" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center" data-id="element-82">
        <FadeIn data-id="element-83">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#E8604C]/10 mb-6" data-id="element-84">
            <HeartHandshake className="w-8 h-8 text-[#E8604C]" data-id="element-85" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2D2A26] mb-6" data-id="element-86">
            El Método de la "Orden Única" y la "Micro-conexión de 60 Segundos"
          </h2>
        </FadeIn>

        <FadeIn delay={200} data-id="element-87">
          <p className="font-sans text-lg md:text-xl text-[#2D2A26]/80 leading-relaxed max-w-3xl mx-auto" data-id="element-88">
            No necesitas horas de terapia. Necesitas cambiar CÓMO entras en su
            radar antes de pedir. Este plan te enseña a construir un puente de
            conexión ultra-rápido para que, cuando hables,
            <strong className="text-[#2D2A26] font-semibold" data-id="element-89">
              {' '}
              el cerebro de tu hijo esté listo para recibir la instrucción y
              cooperar
            </strong>
            , no para resistirse.
          </p>
        </FadeIn>
      </div>
    </section>;
}